import { ApiResult, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { NotificationSetting } from '../models/notification-setting';

export class NotificationsApi {
    constructor(protected baseUrl: string) {}

    public getNotifications = (): Promise<ApiResult<NotificationSetting[]>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/notification-settings`),
            response => response.data
        );

    public createNotification = (notifications: NotificationSetting): Promise<ApiResult<NotificationSetting>> =>
        safeRequest(
            () => request.post(`${this.baseUrl}/notification-settings`, notifications),
            response => response.data
        );

    public deleteNotification = (id: number): Promise<ApiResult<void>> =>
        safeRequest(() => request.delete(`${this.baseUrl}/notification-settings/${id}`), noop);
}
